export const expertPlans = [
  {
    title: 'Avail 65% discount on Assisted Tax filing (Basic)',
    couponCode: 'CTGRABITR',
    validTill: 'Valid till 15th September 2025',
    buyNowUrl:
      'https://cleartax.in/checkout/prod_itr_af_basic?coupon=CTGRABITR',
    knowMoreLink:
      'https://cleartax.in/services/prod_itr_af_basic/p?utm_ref=itr_organic_2025_coupon_code_page',
  },
  {
    title: 'Avail 65% discount on Assisted Tax filing (Premium)',
    couponCode: 'CTGRABITR',
    validTill: 'Valid till 15th September 2025',
    buyNowUrl:
      'https://cleartax.in/checkout/prod_itr_af_premium?coupon=CTGRABITR',
    knowMoreLink:
      'https://cleartax.in/services/prod_itr_af_premium/p?utm_ref=itr_organic_2025_coupon_code_page',
  },
  {
    title: 'Avail 65% discount on Assisted Tax filing (Elite)',
    couponCode: 'CTGRABITR',
    validTill: 'Valid till 15th September 2025',
    buyNowUrl:
      'https://cleartax.in/checkout/prod_itr_af_black?coupon=CTGRABITR',
    knowMoreLink:
      'https://cleartax.in/services/prod_itr_af_black/p?utm_ref=itr_organic_2025_coupon_code_page',
  },
  {
    title: 'Avail 65% discount on Assisted Tax filing (Luxe)',
    couponCode: 'CTGRABITR',
    validTill: 'Valid till 15th September 2025',
    buyNowUrl:
      'https://cleartax.in/checkout/prod_itr_af_luxury?coupon=CTGRABITR',
    knowMoreLink:
      'https://cleartax.in/services/prod_itr_af_luxury/p?utm_ref=itr_organic_2025_coupon_code_page',
  },
  {
    title: 'Avail 65% discount on Assisted Tax filing (Ask An Expert)',
    couponCode: 'CTGRABITR',
    validTill: 'Valid till 15th September 2025',
    buyNowUrl: 'https://cleartax.in/checkout/prod_ask_expert_plan_l',
    knowMoreLink:
      'https://cleartax.in/services/prod_ask_expert_plan/p?utm_ref=itr_organic_2025_coupon_code_page',
  },
];

export const diyPlans = [
  {
    title: 'Avail 65% off on all DIY Plans',
    couponCode: 'CTGRABITR',
    validTill: 'Valid till 15th September 2025',
    buyNowUrl: 'https://cleartax.in/filing',
    knowMoreLink:
      'https://cleartax.in/income-tax-efiling?utm_ref=itr_organic_2025_coupon_code_page',
  },
];
